export const BUY_NOW_DATA_STORAGE_KEY = 'buyNowData';
export const SIGNUP_DATA_STORAGE_KEY = 'signupData';
export const MARKETING_STABLE_ID_COOKIE_NAME = 'hb_statsig_stable_id';
export const MSP_FEATURE_DATE = '2024-03-11';
export const USER_DATA_KEYS = [
    'name',
    'email',
    'auth_token',
    'auth_code',
    'profile_img_url',
    'sso_type'
];
export const GTM_CAMPAIGN_URL_COOKIE_KEY = '__gtm_campaign_url';
export const BUY_NOW_EXPERIENCE_QUERY_PARAM = 'buynowflow';
export const SIGNUP_CONTEXT_PROVIDER_ERROR =
    'useSignupFormContext must be used within SignupContextProvider';
export const SIGNUP_CONTEXT_ACCESS_DENIED_ERROR_MESSAGE =
    'Access denied: Your component will re-render on every keystroke change. This can lead to performance issues. Proceed with caution.';
